<template>
  <div>
    <!-- Resultado de cada momento contable respectivamente -->
    <b-card no-body class="my-3">
      <b-tabs card>
        <b-tab v-for="res in importPoliza.result" :key="res.id" :title="res.content.poliza.momento">
          <polizas-r-m-s-card :item="res"></polizas-r-m-s-card>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PolizasRMSCard from '@/components/Polizas/RMS/PolizasRMSCard'

export default {
  name: 'PolizasRMSTabs',

  components: {
    PolizasRMSCard
  },

  computed: {
    ...mapState('polizasRMSModule', ['importPoliza'])
  }
}
</script>

<style lang="scss" scoped></style>
